export const ADD_DEFERRED_PROMPT = 'ADD_DEFERRED_PROMPT'

export function deferredPromptReducer(state = null, action) {
    switch (action.type){
        case ADD_DEFERRED_PROMPT:
            return action.payload
        default: return state
    }
}